import Vue from 'vue'

const dragModal = Vue.directive('dragModal', {
    bind: function (el, binding, vnode) {
        const startXY = {
            x: 0,
            y: 0
        }
        let translateArr = [0, 0]
        let isDrag = false
        if (binding.value) {
            el.addEventListener('mousedown', starDrag)
            // el.addEventListener('mouseup', stopDrag)
            // el.addEventListener('mousemove', onDrag)
            el.addEventListener('mouseout', stopDrag)
        }
        function starDrag(e) {
            console.log(e.style)
            const modalDOM = el.parentNode
            if (modalDOM.getAttribute('style')) {
                translateArr = modalDOM.getAttribute('style').match(/-{0,1}[0-9]+/g)
            }
            startXY.x = e.x
            startXY.y = e.y
            isDrag = true
            document.documentElement.addEventListener('mousemove', onDrag)
            document.documentElement.addEventListener('mouseup', stopDrag)
        }

        function onDrag(e) {
            if (isDrag) {
                const modalDOM = el.parentNode
                const moveMoveX = Number(translateArr[0]) + e.x - startXY.x // 偏移量x
                const moveMoveY = Number(translateArr[1]) + e.y - startXY.y // 偏移量y
                modalDOM.setAttribute('style', `transform:translate(${moveMoveX}px,${moveMoveY}px)`)
            }
        }

        function stopDrag(e) {
            document.documentElement.removeEventListener('mousemove', onDrag)
            document.documentElement.removeEventListener('mouseup', stopDrag)
            isDrag = false
        }
    }
})

export default dragModal
